!function() {
  "use strict";
  customElements.get("delivery-message") || customElements.define("delivery-message", class extends HTMLElement {
    constructor() {
      super(), this.cacheElements();
      const t = this.querySelector("[data-delivery-option-data]");
      try {
        this.data = t?.innerHTML ? JSON.parse(t.innerHTML) : null;
      } catch (t) {
        console.error("Failed to parse delivery data:", t), this.data = null;
      }
      if (this.excludedDatesSet = new Set, this.memoizedDeliveryDates = new Map, this.cutoffHour = null, 
      this.data && this.data.cutoff) {
        const t = new Date(this.data.cutoff);
        this.cutoffHour = t.getUTCHours();
      }
      this.dayNameToNumber = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
      }, this.excludedDaysOfWeek = new Set, this.data && this.data.days_excluded && Array.isArray(this.data.days_excluded) && this.data.days_excluded.forEach((t => {
        const e = this.dayNameToNumber[t];
        void 0 !== e && this.excludedDaysOfWeek.add(e);
      })), this.locale = window.Shopify && window.Shopify.locale ? `${window.Shopify.locale}${window.Shopify.country ? "-" + window.Shopify.country : ""}` : document.documentElement.lang || navigator.language || "en", 
      this.monthFormatterLong = new Intl.DateTimeFormat(this.locale, {
        month: "long",
        timeZone: "UTC"
      }), this.monthFormatterShort = new Intl.DateTimeFormat(this.locale, {
        month: "short",
        timeZone: "UTC"
      });
    }
    cacheElements() {
      this.elements = Object.fromEntries(Object.entries({
        cutoffEl: "[data-delivery-cutoff-container]",
        countdownEl: "[data-delivery-countdown-container]",
        genericEl: "[data-delivery-generic-container]",
        regularContainerEl: "[data-delivery-container]",
        countdownTextEl: "[data-delivery-countdown]"
      }).map((t => {
        let [e, i] = t;
        return [ e, this.querySelector(i) ];
      }))), this.elements.dateEls = this.querySelectorAll("[data-delivery-date]"), this.elements.dateRangeEls = this.querySelectorAll("[data-delivery-date-range]");
    }
    formatCountdown(t, e, i) {
      const a = window.strings.timeUnitAbbreviation, n = [];
      if (t > 0 && n.push({
        value: t,
        unit: "hour"
      }), e > 0 && n.push({
        value: e,
        unit: "minute"
      }), i > 0 && n.push({
        value: i,
        unit: "second"
      }), 0 === n.length) return `0${a.second}`;
      const s = n.slice(0, 2).map((t => `${t.value}${a[t.unit]}`));
      return 2 === s.length ? `${s[0]} ${window.strings.conjunction} ${s[1]}` : s.join("");
    }
    updateCountdown(t) {
      const {countdownTextEl: e} = this.elements;
      if (!e) return !1;
      const i = new Date, a = 3600 * (t - i.getUTCHours()) - 60 * i.getUTCMinutes() - i.getUTCSeconds();
      if (a < 0 || a < 60) return e.textContent = this.formatCountdown(0, 1, 0), !1;
      const n = Math.floor(a / 3600), s = Math.floor(a % 3600 / 60), o = a % 60;
      return e.textContent = this.formatCountdown(n, s, o), !0;
    }
    toggleVisibility(t, e) {
      t && (t.classList.toggle("hidden", !e), t.classList.toggle("opacity-0", !e), t.setAttribute("aria-hidden", String(!e)));
    }
    formatDateForExclusion(t) {
      return t.toISOString().split("T")[0].replace(/-/g, "/");
    }
    isDateExcluded(t) {
      const e = this.formatDateForExclusion(t), i = t.getUTCDay();
      return this.excludedDatesSet.has(e) || this.excludedDaysOfWeek.size > 0 && this.excludedDaysOfWeek.has(i);
    }
    calculateDeliveryDate(t, e, i) {
      const a = `${t}-${e.toISOString().split("T")[0]}-${e.getUTCHours()}-${i}`;
      if (this.memoizedDeliveryDates.has(a)) return new Date(this.memoizedDeliveryDates.get(a));
      const n = new Date(e);
      null !== i && e.getUTCHours() >= i && n.setUTCDate(n.getUTCDate() + 1);
      let s = 0;
      for (;s < t; ) n.setUTCDate(n.getUTCDate() + 1), this.isDateExcluded(n) || s++;
      return this.memoizedDeliveryDates.set(a, n.toISOString()), n;
    }
    formatDeliveryDate(t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        includeDay: !0,
        shortMonth: !1,
        includeMonth: !0
      };
      const {includeDay: i, shortMonth: a, includeMonth: n} = e, s = this.locale, o = {
        day: i ? "numeric" : void 0,
        month: n ? a ? "short" : "long" : void 0
      };
      let l = new Intl.DateTimeFormat(s, o).format(t);
      if (i && s.startsWith("en")) {
        const t = t => t + ({
          one: "st",
          two: "nd",
          few: "rd",
          other: "th"
        }[new Intl.PluralRules(s, {
          type: "ordinal"
        }).select(t)] || "th");
        l = l.replace(/\b(\d{1,2})\b/, ((e, i) => t(Number(i))));
      }
      return l;
    }
    updateElementContent(t, e) {
      t && null !== e && t.forEach((t => {
        t.textContent !== e && (t.textContent = e);
      }));
    }
    updateDisplay() {
      if (!this.data) return;
      const t = new Date, {minimum_days: e, maximum_days: i, dates_excluded: a, cutoff: n} = this.data;
      0 === this.excludedDatesSet.size && a && a.split(",").map((t => t.trim())).forEach((t => this.excludedDatesSet.add(t)));
      const s = this.cutoffHour;
      (!this.lastDateUpdate || t - this.lastDateUpdate >= 6e4) && (this.updateDeliveryDates(t, e, i, s), 
      this.lastDateUpdate = t), this.updateVisibility(t, s);
    }
    isMonthBeforeDay() {
      if (void 0 !== this._monthBeforeDay) return this._monthBeforeDay;
      const t = new Intl.DateTimeFormat(this.locale, {
        year: "numeric",
        month: "short",
        day: "numeric"
      }).formatToParts(new Date), e = t.findIndex((t => "month" === t.type)), i = t.findIndex((t => "day" === t.type));
      return this._monthBeforeDay = e < i, this._monthBeforeDay;
    }
    updateDeliveryDates(t, e, i, a) {
      const {dateEls: n, dateRangeEls: s} = this.elements, o = this.calculateDeliveryDate(i, t, a), l = this.formatDeliveryDate(o);
      if (n.length > 0 && this.updateElementContent(n, l), s.length > 0) {
        const i = this.calculateDeliveryDate(e, t, a);
        if (i.getUTCMonth() === o.getUTCMonth() && i.getUTCFullYear() === o.getUTCFullYear() && i.getUTCDate() === o.getUTCDate()) return void this.updateElementContent(s, this.formatDeliveryDate(o, {
          includeDay: !0,
          shortMonth: !0,
          includeMonth: !0
        }));
        const n = this.isMonthBeforeDay(), l = this.formatDeliveryDate(i, {
          includeDay: !0,
          shortMonth: !0,
          includeMonth: n
        }), r = this.formatDeliveryDate(o, {
          includeDay: !0,
          shortMonth: !0,
          includeMonth: !n
        });
        this.updateElementContent(s, `${l} - ${r}`);
      }
    }
    updateVisibility(t, e) {
      e && t.getUTCHours() < e ? this.elements.countdownEl ? (this.updateCountdown(e), 
      this.toggleVisibility(this.elements.cutoffEl, !1), this.toggleVisibility(this.elements.countdownEl, !0), 
      this.toggleVisibility(this.elements.genericEl, !1)) : (this.toggleVisibility(this.elements.cutoffEl, !0), 
      this.toggleVisibility(this.elements.genericEl, !1)) : (this.toggleVisibility(this.elements.genericEl, !0), 
      this.toggleVisibility(this.elements.cutoffEl, !1), this.toggleVisibility(this.elements.countdownEl, !1)), 
      this.toggleVisibility(this.elements.regularContainerEl, !0);
    }
    connectedCallback() {
      this.data && (this.data.dates_excluded && this.data.dates_excluded.split(",").map((t => t.trim())).forEach((t => this.excludedDatesSet.add(t))), 
      this.updateDisplay(), this.updateInterval = setInterval((() => {
        this.updateDisplay();
      }), 1e3));
    }
    disconnectedCallback() {
      clearInterval(this.updateInterval), this.updateInterval = null, this.excludedDatesSet.clear(), 
      this.excludedDaysOfWeek.clear(), this.data = null, this.elements = null;
    }
  });
}();